import { useEffect, useState } from "react";
import { History } from "lucide-react";
import api from "@/lib/api";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const LastRateHint = ({ itemId, partyId, side = "sales", currentRate, onApply, testId }) => {
  const [last, setLast] = useState(null);
  useEffect(() => {
    if (!itemId || !partyId) { setLast(null); return; }
    api.get(`/items/${itemId}/last-rate`, { params: { party_id: partyId, side } })
      .then((r) => setLast(r.data.found ? r.data : null)).catch(() => setLast(null));
  }, [itemId, partyId, side]);
  if (!last) return null;
  const same = Number(last.rate) === Number(currentRate);
  return (
    <div className="flex items-center gap-1.5 text-[10px] text-muted-foreground" data-testid={testId}>
      <History className="w-3 h-3" />
      <span>Last: {inr(last.rate)}{last.discount_pct ? ` (−${last.discount_pct}%)` : ""} on {last.date} · {last.number}</span>
      {!same && (
        <button type="button" className="text-accent underline" onClick={() => onApply(last)} data-testid={`${testId}-apply`}>use</button>
      )}
    </div>
  );
};
